import { useTranslation } from 'react-i18next';
import TelegramIcon from '@mui/icons-material/Telegram';
import ChatIcon from '@mui/icons-material/Chat';

import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';


export const SupportLinks = () => {
    const { t } = useTranslation();
    let support_chats = {
        "telegram": "https://t.me/nestarenie_expert",
        "max": "https://max.ru/join/pJTSKVLazsHseSJ1KDjkZDCqR4NYyoqqULSMdDL_MsA",
    }

    return (
        <Box sx={{ textAlign: "center" }}>
            {support_chats.telegram &&
                <Button variant="text" component={Link} to={support_chats.telegram} target="_blank"
                        sx={{
                            fontSize: "14px",
                            textTransform: "none",
                            mb: 0,
                        }}>
                    <TelegramIcon sx={{ mr: 1 }} /> {t("чат поддержки")}
                </Button>
            }
            {support_chats.max &&
                <Button variant="text" component={Link} to={support_chats.max} target="_blank"
                        sx={{
                            textTransform: "none",
                            fontSize: "14px"
                        }}>
                    <ChatIcon sx={{ mr: 1 }} /> {t("чат поддержки")}
                </Button>
            }
        </Box>
    )
}
